import { TypedUseSelectorHook, useSelector, useDispatch } from 'react-redux';
import { ApplicationDispatch, ApplicationStateType } from '../redux/store';

const useAppSelector: TypedUseSelectorHook<ApplicationStateType> = useSelector;
const useAppDispatch: () => ApplicationDispatch = useDispatch;
export { useAppSelector, useAppDispatch };
